const loanManagerAbi = [
  {
    inputs: [],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
    ],
    name: 'OwnableInvalidOwner',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'OwnableUnauthorizedAccount',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'loanId',
        type: 'uint256',
      },
      {
        components: [
          {
            internalType: 'address',
            name: 'nftContract',
            type: 'address',
          },
          {
            internalType: 'uint256[]',
            name: 'tokenIds',
            type: 'uint256[]',
          },
          {
            internalType: 'address',
            name: 'borrower',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'lender',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'loanAmount',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'aprBasisPoints',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'loanDuration',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'currencyERC20',
            type: 'address',
          },
        ],
        indexed: false,
        internalType: 'struct LoanManager.LoanData',
        name: '',
        type: 'tuple',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'loanInitialTime',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'isPaid',
        type: 'bool',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'isClosed',
        type: 'bool',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'isApproved',
        type: 'bool',
      },
    ],
    name: 'LoanCreated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    inputs: [],
    name: 'BPS',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'MAX_APR',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'NFT_MAX_LIMIT',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: '_proxy',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'nftContract',
            type: 'address',
          },
          {
            internalType: 'uint256[]',
            name: 'tokenIds',
            type: 'uint256[]',
          },
          {
            internalType: 'address',
            name: 'borrower',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'lender',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'loanAmount',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'aprBasisPoints',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'loanDuration',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'currencyERC20',
            type: 'address',
          },
        ],
        internalType: 'struct LoanManager.LoanData',
        name: 'loanData',
        type: 'tuple',
      },
      {
        internalType: 'uint256',
        name: 'lenderReceiptId',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'borrowerReceiptId',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'nonce',
        type: 'uint256',
      },
    ],
    name: 'createLoan',
    outputs: [
      {
        internalType: 'uint256',
        name: 'loanId',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_contract',
        type: 'address',
      },
      {
        internalType: 'uint256[]',
        name: '_tokenIds',
        type: 'uint256[]',
      },
      {
        internalType: 'address',
        name: '_borrower',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_nonce',
        type: 'uint256',
      },
    ],
    name: 'getLoan',
    outputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'nftContract',
            type: 'address',
          },
          {
            internalType: 'uint256[]',
            name: 'tokenIds',
            type: 'uint256[]',
          },
          {
            internalType: 'address',
            name: 'borrower',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'lender',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'loanAmount',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'aprBasisPoints',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'loanDuration',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'currencyERC20',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'loanInitialTime',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'lenderReceiptId',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'borrowerReceiptId',
            type: 'uint256',
          },
          {
            internalType: 'bool',
            name: 'isPaid',
            type: 'bool',
          },
          {
            internalType: 'bool',
            name: 'isDefault',
            type: 'bool',
          },
          {
            internalType: 'bool',
            name: 'isApproved',
            type: 'bool',
          },
        ],
        internalType: 'struct LoanManager.Loan',
        name: 'loan',
        type: 'tuple',
      },
      {
        internalType: 'uint256',
        name: 'loanId',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'loanId',
        type: 'uint256',
      },
    ],
    name: 'getLoanById',
    outputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'nftContract',
            type: 'address',
          },
          {
            internalType: 'uint256[]',
            name: 'tokenIds',
            type: 'uint256[]',
          },
          {
            internalType: 'address',
            name: 'borrower',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'lender',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'loanAmount',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'aprBasisPoints',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'loanDuration',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'currencyERC20',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'loanInitialTime',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'lenderReceiptId',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'borrowerReceiptId',
            type: 'uint256',
          },
          {
            internalType: 'bool',
            name: 'isPaid',
            type: 'bool',
          },
          {
            internalType: 'bool',
            name: 'isDefault',
            type: 'bool',
          },
          {
            internalType: 'bool',
            name: 'isApproved',
            type: 'bool',
          },
        ],
        internalType: 'struct LoanManager.Loan',
        name: 'loan',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'loanReceiptID',
        type: 'uint256',
      },
    ],
    name: 'getLoanId',
    outputs: [
      {
        internalType: 'uint256',
        name: 'loanID',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'loanId',
        type: 'uint256',
      },
    ],
    name: 'getPayoffAmount',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'nftLimit',
        type: 'uint256',
      },
    ],
    name: 'proposeNftMaxLimit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newProxy',
        type: 'address',
      },
    ],
    name: 'proposeProxyManager',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'loanReceiptID',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'loanId',
        type: 'uint256',
      },
    ],
    name: 'setLoanId',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'setNftMaxLimit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'setProxyManager',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'loanId',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'state',
        type: 'bool',
      },
    ],
    name: 'updateIsApproved',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'loanId',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'state',
        type: 'bool',
      },
    ],
    name: 'updateIsDefault',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'loanId',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'state',
        type: 'bool',
      },
    ],
    name: 'updateIsPaid',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

export { loanManagerAbi };
